import { Component, ElementRef, OnInit, inject } from '@angular/core';
import {NgClass, NgStyle} from "@angular/common";
import {TooltipModule} from "../tooltip/tooltip.module";
import {TranslatePipe} from "@ngx-translate/core";
import {fromEvent, skip, Subject, takeUntil} from "rxjs";
import {filter} from "rxjs/operators";
import {DialogInteractableService} from "../services/dialog-interactable/dialog-interactable.service";

@Component({
    selector: 'app-color-picker',
    imports: [
        NgStyle,
        TooltipModule,
        TranslatePipe,
        NgClass
    ],
    templateUrl: './color-picker.component.html',
    styleUrl: './color-picker.component.scss'
})
export class ColorPickerComponent implements OnInit {
    private readonly el = inject(ElementRef);
    private readonly popoverInteractableService = inject(DialogInteractableService);

    public colors = ['#ff8800', '#57d59b', '#7e51d8', '#2c75c8', '#5db3ff', '#62d6ed', '#64f370',
        '#6ba645', '#b2e95e', '#ffe500', '#ff1746', '#9d681f', '#7c7c7c', '#000000'];

    public set parameter(parameter: string) {
        if (parameter) {
            this.selectedColor = parameter;
        }
    }

    public resultSubject: Subject<string>;
    public selectedColor: string;

    private destroy$ = new Subject<void>();

    ngOnInit() {
        fromEvent(document, 'click')
            .pipe(
                filter((event: Event) => !this.el.nativeElement.contains(event.target)),
                skip(1),
                takeUntil(this.destroy$)
            )
            .subscribe(() => {
                this.closePopover();
            });
    }

    public selectColor(selectedColor: string) {
        this.selectedColor = selectedColor;
        this.resultSubject.next(this.selectedColor);
    }

    public revert() {
        this.resultSubject.next(null);
        this.closePopover();
    }

    private closePopover() {
        this.destroy$.next();
        this.destroy$.complete();
        this.popoverInteractableService.close();
    }
}
